import { gql } from '@apollo/client';

export const MESSAGE_FIELDS = gql`
  fragment MessageFields on Message {
    id
    value
    source
    sourceId
    createdAt
    updatedAt
    userId
    parentMessageId
    author {
      displayName
    }
    messageContexts {
      name
      value
      document {
        id
        path
      }
    }
  }
`;
